/**
 * Reusable public-language guardrail for AI visibility claims.
 *
 * The 24 September 2026 benchmark article explains why an AI visibility number
 * is only meaningful when its sampling method is visible. Keep this copy
 * aligned with the article rather than treating a study-specific observation
 * as a promise or market-wide rate.
 */
export const AI_VISIBILITY_MEASUREMENT_METHOD =
  "AI visibility has no universal score: record the engine, prompt panel, observation date and visible evidence for each measurement. Citations, rankings and leads are observed, not guaranteed.";

export const AI_VISIBILITY_BENCHMARK_CONTEXT =
  "Walker Sands' H1 2026 benchmark covered more than 45 million relevant Google keywords across 828 enterprise B2B companies in 14 technology sectors. It reported a 3.0% median citation-inclusion rate and 4.6% of companies receiving no citations; those observations are specific to that defined study and are not a transferable market-wide promise.";
